import { Box, Card, Grid, Typography } from '@mui/material';
import { Datagrid, ListBase, NumberField, Pagination, TextField, useTranslate } from 'react-admin';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';

const Columns = () => (
  <Datagrid
    bulkActionButtons={false}
    rowClick={false}
    sx={{
      '.RaBulkActionsToolbar-toolbar': {
        position: 'relative !important',
        transform: 'none !important',
      },
      '& .left-col': { textAlign: 'left' },
    }}
  >
    <TextField source="swaps" label="module.swapUserRanking.swaps" sortable={false} />
    <NumberField
      source="totalUsd"
      label="module.swapUserRanking.totalUsd"
      cellClassName="left-col"
      headerClassName="left-col"
      sortable={false}
    />
    <TextField source="address" label="module.swapUserRanking.address" sortable={false} />
  </Datagrid>
);

const RankingPanel = ({ title, metric }: { title: string; metric: 'amount' | 'count' }) => (
  <Card sx={{ p: 2, height: '100%' }}>
    <Typography variant="subtitle1" sx={{ mb: 1 }}>
      {title}
    </Typography>

    <ListBase
      resource={Resources.swapUserRanking}
      perPage={10}
      disableSyncWithLocation
      queryOptions={{ meta: { metric } }}
    >
      <Box sx={{ overflow: 'auto' }}>
        <Columns />
      </Box>
      <Box sx={{ mt: 1 }}>
        <Pagination />
      </Box>
    </ListBase>
  </Card>
);

const Ranking = () => {
  const t = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-user-ranking" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={t('resource.swapUserRanking')}
          links={[
            { name: t('resource.swapUser'), href: '#' },
            { name: t('resource.swapUserRanking'), href: `/${Resources.swapUserRanking}` },
            { name: t('resource.list') },
          ]}
        />

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RankingPanel
              title={t('module.swapUserRanking.byAmount') || '按金额排名'}
              metric="amount"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <RankingPanel
              title={t('module.swapUserRanking.byCount') || '按次数排名'}
              metric="count"
            />
          </Grid>
        </Grid>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default Ranking;
